<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router
    >
      <li class="nav-header" @click="toActList">
        <div class="goBack">
          <i class="el-icon-arrow-left"></i>
          {{isSuperAdmin?"返回":"退出登录"}}
        </div>
      </li>
      <template v-for="item in menus">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <template v-if="subItem.subs">
                <el-submenu :index="subItem.index" :key="subItem.index">
                  <template slot="title">{{ subItem.title }}</template>
                  <el-menu-item
                    v-for="(threeItem, i) in subItem.subs"
                    :key="i"
                    :index="threeItem.index"
                  >{{ threeItem.title }}</el-menu-item>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item :index="subItem.index" :key="subItem.index">{{ subItem.title }}</el-menu-item>
              </template>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { getSession, setSession } from "@/utils/utils.js";
import LoginAjax from "@/utils/https/modules/Login.request.js";
export default {
  name: "submenu",
  data() {
    return {
      collapse: false,
      activityID: 0,
      menus: [],
      isSuperAdmin:true,
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path;
    }
  },
  methods: {
    toActList() {
      if(this.isSuperAdmin){
        this.$router.push("/activity");
      }else{
        // 执行登出
        this.handleCommand();
      }
    },
    async handleCommand() {
      try {
        await LoginAjax.logout();
        this.$message.success("成功退出");
        sessionStorage.removeItem("yxtoken");
        sessionStorage.removeItem("admindetail");
        sessionStorage.removeItem("issuperadmin");
        this.$router.push("/login");
      } catch (error) {
        this.$message.error(error);
      }
    },
  },
  created() {
    this.$bus.$on("collapse", msg => {
      this.jurisdiction = msg;
      this.collapse = msg;
    });
  },
  mounted() {
    // 判断是否活动管理员，进行菜单的屏蔽跳转
    this.isSuperAdmin = getSession("issuperadmin")===false?false:true;
    this.activityID = this.$route.params.activityID;
    if(this.isSuperAdmin){
      this.menus = [
        {
          icon: "el-icon-s-promotion",
          index: `/activity/baseinfo/${this.activityID}`,
          title: "基本设置"
        },
        {
          icon: "el-icon-s-home",
          index: `/activity/brandstore/${this.activityID}`,
          title: "品牌门店设置"
        },
        {
          icon: "el-icon-s-goods",
          index: `/activity/marketing/${this.activityID}`,
          title: "营销设置"
        },
        {
          icon: "el-icon-s-tools",
          index: `/activity/settings/${this.activityID}`,
          title: "页面配置"
        },
        {
          icon: "el-icon-s-flag",
          index: `/activity/guide/${this.activityID}`,
          title: "导购员设置"
        },
        {
          icon: "el-icon-s-marketing",
          index: `/activity/statistics/${this.activityID}`,
          title: "数据统计"
        },
        {
          icon: "el-icon-s-finance",
          index: `/activity/finance/${this.activityID}`,
          title: "财务"
        },
        {
          icon: "el-icon-s-custom",
          index: `/activity/userset/${this.activityID}`,
          title: "管理员列表"
        }
      ];
    }else{
      this.menus = [
        {
          icon: "el-icon-s-flag",
          index: `/activity/guide/${this.activityID}`,
          title: "导购员设置"
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
  background-color: rgb(50, 65, 87);
  & > ul {
    height: 100%;
  }
  .nav-header {
    display: flex;
    align-items: center;
    padding: 30px 0;
    background: #2c3b52;
    color: #fff;
    .goBack {
      padding-left: 40px;
      font-size: 20px;
    }
  }
  .el-menu-item,
  .el-submenu {
    .vzaniconfont {
      display: inline-block;
      margin-right: 5px;
      min-width: 24px;
      max-width: 24px;
      text-align: center;
      font-size: 18px;
      color: #bfcbd9;
    }
    .el-submenu__title {
      height: 50px;
      line-height: 50px;
    }
  }
}

.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 220px;
}
</style>
